import type { Metadata } from 'next'
import WhatsAppMessages from '@/Component/Admin/WhatsAppMessages'

export const metadata: Metadata = {
    title: 'WhatsApp Messages | Connector Club',
    description: '',
}

const WhatsAppMessagesPage = () => {
    return (
        <WhatsAppMessages />
    )
}

export default WhatsAppMessagesPage
